import { isPipeSizeValid } from "../../components/BatchSelectionDataTable/helpers/getColumnsValidation";
import { BatchSelectionRow } from "../types";
import { getEmptyRow } from "./getEmptyRow";
import { isRowEmpty } from "./isRowEmpty";

export function ensureDataState(
  data: BatchSelectionRow[],
): BatchSelectionRow[] {
  return ensureTrailingEmptyRow(ensureQuantityFilled(data));
}

function ensureQuantityFilled(data: BatchSelectionRow[]): BatchSelectionRow[] {
  const result = [...data];
  for (let i = 0; i < result.length; i++) {
    const row = result[i];
    if (isRowEmpty(row)) continue;
    if (row.quantity === "") {
      result[i] = { ...row, quantity: "1" };
    }
    if (isPipeSizeValid(row.pipeSize) !== true) {
      result[i] = { ...row, pipeSize: getEmptyRow().pipeSize };
    }
  }
  return result;
}

function ensureTrailingEmptyRow(
  data: BatchSelectionRow[],
): BatchSelectionRow[] {
  const result = data.filter((row) => !isRowEmpty(row));
  while (
    result.length >= 2 &&
    isRowEmpty(result.at(-1)) &&
    isRowEmpty(result.at(-2))
  ) {
    result.pop();
  }
  if (!isRowEmpty(result.at(-1)) || result.length === 0) {
    result.push(getEmptyRow());
  }
  return result;
}
